'use client'

import cn from 'classnames'
import {observer} from 'mobx-react'
import React, {useCallback, useEffect, useState} from 'react'
import styled from 'styled-components'

import * as UI from './burger.styles'

const BurgerContent = styled(
  ({
    className,
    open,
    dark,
    onClick,
  }: {
    className?: string
    open: boolean
    dark?: boolean
    onClick?: () => void
  }) => (
    <UI.Wrapper onClick={onClick} className={cn(className)}>
      <UI.BurgerBtn className={cn({open})}>
        <UI.BurgerButtonBars $dark={dark} />
      </UI.BurgerBtn>
    </UI.Wrapper>
  ),
)``

export interface IProps extends Omit<
  React.HTMLProps<HTMLButtonElement> & {
    outlined?: boolean
    open?: boolean
  },
  'onChange'
> {
  onChange: (open: boolean) => void
  dark?: boolean
}

export const BurgerButton = function Component({
  children,
  open: openProp,
  onChange,
  outlined,
  className,
                                                 dark,
  ref,
}: IProps) {
  const openDefault = openProp || false
  const [open, setOpen] = useState(openDefault)

  useEffect(() => {
    setOpen(openDefault)
  }, [openDefault])

  const onClick = useCallback(() => {
    setOpen(!open)
  }, [open])

  useEffect(() => {
    if (onChange) {
      onChange(open)
    }
  }, [open])

  return (
    <UI.ButtonWrapped
      outlined={outlined}
      className={className}
      onClick={onClick}
      type="button"
      ref={ref}>
      <BurgerContent open={open} onClick={onClick} dark={dark} />
      {children}
    </UI.ButtonWrapped>
  )
}

export const MobileBurger = observer(
  ({
    className,
    open,
    onClick,
    dark,
  }: {
    className?: string
    open: boolean
    dark?: boolean
    onClick: (open: boolean) => void
  }) => {
    return (
      <BurgerContent open={open} onClick={() => onClick(open)} className={className} dark={dark} />
    )
  },
)
